var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.8V8.8H1.8V5.8H5V4H3.2V0H8V4H6.2V5.8H9.4V8.8H11.2V12.8H6.4V8.8H8.2V7H3V8.8H4.8V12.8H0ZM4.4 2.8H6.8V1.2H4.4V2.8ZM1.2 11.6H3.6V10H1.2V11.6ZM7.6 11.6H10V10H7.6V11.6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.3d082f9b4eb9a55e22530ea66becbbc4.svg";
export { ForwardRef as ReactComponent };